import React from "react" 
import ReactDOM from "react-dom"

export default (component, props) => {
	return (instance, td, row, col, prop, value, cellProperties) => {
		ReactDOM.render(<component.rowComponent.component {...props} row={component} />, td)
	}
}



// WEBPACK FOOTER //
// ./src/component/scenarii/common/sub-table-renderer.js